module.exports = __webpack_public_path__ + "static/img/Jeremy-Cameron.65ef378.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jeremy-Cameron.jpg
// module id = hqbe
// module chunks = 0